<div class="page payments">
  <h1 class="c-h1">{{ 'MENU.payments-overview-title' | translate }}</h1>

  @if (state$ | async; as state) {
    <myabvv-filter [isLoading]="state.loading" (applyFilterEvent)="onApplyFilter()" (reinitializeFiltersEvent)="onReinitializeFilters()">
      <myabvv-date-filter class="l-grid__unit  l-grid__unit--4of12@medium" [datePickerOptionsDate]="datePickerOptionsStartDate" (changeDateEvent)="onChangeStartDate($event)" [date]="startDate" [label]="'CALENDAR.from' | translate"></myabvv-date-filter>
      <myabvv-date-filter class="l-grid__unit  l-grid__unit--4of12@medium" [datePickerOptionsDate]="datepickerOptionsEndDate" (changeDateEvent)="onChangeEndDate($event)" [date]="endDate" [label]="'CALENDAR.till' | translate"></myabvv-date-filter>
      <myabvv-dropdown-filter class="l-grid__unit l-grid__unit--4of12@medium" (changeValueEvent)="onChangeViewEvent($event)" [values]="viewsToSort" [label]="'ALLOWANCES.OVERVIEW.sort_by' | translate"></myabvv-dropdown-filter>
    </myabvv-filter>

    <section class="calculation-date group">
      <!-- OVERVIEW -->
      @if (state.loading) {
        <div class="row justify-content-center">
          <myabvv-loader [message]="'GENERAL.busy_loading' | translate"></myabvv-loader>
        </div>
      }
      @if (!state.loading && !hasData() && !state.error) {
        <div class="info-card-empty">
          <i class="fa fa-inbox info-card-empty__icon"></i>
          <span>{{ 'ALLOWANCES.OVERVIEW.no_data' | translate }}</span>
        </div>
      }
      <myabvv-alert [condition]="state.error" [message]="'USER_FEEDBACK.error_occurred'" [type]="'error'"></myabvv-alert>

      @if (showByDate() && !state.loading && hasData()) {
        <myabvv-allowances-overview-list-by-date
          [paymentsOverview]="sortedData()"
        (selectPaymentEvent)="onGoToDetail($event)"></myabvv-allowances-overview-list-by-date>
      }

      @if (showByMonth() && !state.loading && hasData()) {
        <myabvv-allowances-overview-list-by-month
          [paymentsOverview]="sortedData()"
        (selectPaymentEvent)="onGoToDetail($event)"></myabvv-allowances-overview-list-by-month>
      }

      <ul class="pagination mt-5">
        @if (activeYear() && !state.loading && state.data) {
          <myabvv-pagination [pages]="state.data.listOfYear" [activePage]="activeYear()"
          (selectPageEvent)="onGetPaymentOverviewOfYear($event)"></myabvv-pagination>
        }
      </ul>
    </section>
  }
</div>
